import React, { useState, useCallback } from "react";
import Modal from "@adsk/alloy-react-modal";
import { OverflowTooltip } from "@adsk/alloy-react-tooltip";
import styled from "styled-components";
import { Issue } from "@adsk/acc-issues-types";
import { IssueSnapshotImageErrorState } from "./IssueSnapshotImageErrorState";
import { useTranslations } from "@adsk/acc-issues-translations";

const StyledImg = styled.img`
  flex: auto;
  max-width: 95vw;
  max-height: calc(90vh - 71px);
  object-fit: contain;
  display: block;
`;

const RelativeDiv = styled.div`
  position: relative;
`;

const ErrorWrapper = styled.div`
  display: flex;
  justify-content: stretch;
  align-items: stretch;
  min-width: min(500px, 90vw);
  min-height: min(300px, 50vh);
  flex: 1;
`;

export const IssueSnapshotView = ({
  imageUrl,
  isOpen,
  issue,
  onClose,
  renderHeader,
  renderActionButtons,
}: {
  imageUrl: string;
  isOpen: boolean;
  issue: Issue;
  onClose: () => void;
  renderHeader?: () => JSX.Element;
  renderActionButtons?: () => JSX.Element;
}) => {
  const { T } = useTranslations();
  const [showErrorState, setShowErrorState] = useState(false);
  const handleImageError = useCallback(e => {
    setShowErrorState(true);
    console.error(e);
  }, []);

  if (!isOpen) {
    return null;
  }

  return (
    <Modal
      open={true}
      style={{
        width: "fit-content",
        height: "fit-content",
        overflow: "hidden",
      }}
      data-dd-action-name="<MASKED-DATA>"
    >
      <Modal.Header style={{ gap: "10px" }}>
        {renderHeader ? (
          renderHeader()
        ) : (
          <OverflowTooltip
            getTargetProps={() => ({
              style: { overflow: "hidden" },
            })}
          >
            {T.translate("thumbnailField.snapshotView.title")} #
            {issue.displayId} - {issue.title}
          </OverflowTooltip>
        )}
        <Modal.Close onClick={onClose} />
      </Modal.Header>
      <Modal.Body
        style={{
          padding: "0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {showErrorState ? (
          <ErrorWrapper>
            <IssueSnapshotImageErrorState />
          </ErrorWrapper>
        ) : (
          <RelativeDiv>
            <StyledImg
              data-testid="thumbnail-view-image"
              src={imageUrl}
              onError={handleImageError}
            />
            {renderActionButtons?.()}
          </RelativeDiv>
        )}
      </Modal.Body>
    </Modal>
  );
};
